import React, { Suspense } from 'react'

import { FormBlockerElementLocalImageElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { ErrorBoundary } from '@cash-web/shared-feature-error'

// The Arcade icons package is designed to be tree shaken, however many are loaded inside LocalImageElement due to the server determining which icon to show.
// To reduce the amount of icons included in the main bundle, this file can be lazy loaded. In turn the icons are tree shaken into their own chunk.
// Prefetching allows for no percievable difference in behavior (layout shift, etc.) due to lazy loading.
const LazyLocalImageElement = React.lazy(() => import(/* webpackPrefetch: true */ './LocalImageElement.lazy'))

const LocalImageElement = (props: FormBlockerElementLocalImageElement) => {
  return (
    <ErrorBoundary FallbackComponent={() => null}>
      <Suspense fallback={<div data-testid="loading-image-element" />}>
        <LazyLocalImageElement {...props} />
      </Suspense>
    </ErrorBoundary>
  )
}

export default LocalImageElement
